export const parseQueryParams = () => {
  return new URLSearchParams(document.location.search)
}
